import { useEffect } from 'react';

// Set only in production builds (.env.production); QA builds clear it, so the QA site sends nothing.
const STACKADAPT_ID = process.env.REACT_APP_STACKADAPT_ID;

export const StackAdapt = () => {
  useEffect(() => {
    if (!STACKADAPT_ID) return undefined;
    const script = document.createElement('script');
    script.innerHTML = `!function(s,a,e,v,n,t,z){if(s.saq)return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');saq('rt', '${STACKADAPT_ID}');`;
    document.head.appendChild(script);

    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.src = `https://tags.srv.stackadapt.com/rt?sid=${STACKADAPT_ID}`;
    img.width = 1;
    img.height = 1;
    noscript.appendChild(img);
    document.head.appendChild(noscript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);

  return null;
};

/**
 * Tracks a checkout conversion event with StackAdapt
 * This should be called on the order confirmation page when a purchase is completed
 *
 * @param revenue - The total GMV/revenue for the order
 * @param orderId - The order ID/number (used for both order_id and cart_id parameters)
 */
export const trackStackAdaptConversion = (revenue: number, orderId: string) => {
  try {
    // Check if StackAdapt is loaded
    if (typeof window !== 'undefined' && (window as any).saq) {
      // Fire the conversion pixel with dynamic parameters
      (window as any).saq('ts', 'ceZJILiyAmsPeemuQWePLQ', {
        revenue: revenue.toString(),
        order_id: orderId,
        cart_id: orderId,
        menu_type: 'external',
        event_type: 'checkout'
      });
    }
  } catch (error) {
    // StackAdapt tracking failed silently
  }
};
